module.exports = __webpack_public_path__ + "img/inquiry.8fd62043.png";